import { createFileRoute } from "@tanstack/react-router";
import { SubagentGovernancePage } from "@/features/agent-subagent-governance/pages/subagent-governance-page";

// Thin shim: the multi-agent delegation governance surface (enablement + lineage + maker-checker inbox).
// No search params / prefetch — it mounts the feature page, which reads from its own query hooks.
export const Route = createFileRoute("/_authed/tenants/$slug/agents/delegation-governance")({
  component: SubagentGovernancePage,
});
